angular.module('aprima-core-ui').directive('lazySrc',
    ['$window', '_', 'uxConstants', '$timeout', '$rootScope', 'AprimaRestangular',
        function ($window, _, uxConstants, $timeout, $rootScope, Restangular) {

            'use strict';

            // Load Image source.
            var loadImg = function (elm, attrs, ignoreCache) {
                ignoreCache = ignoreCache || false;
                if(attrs.lazySrc) {
                    Restangular.get(attrs.endpointBase, {ignoreCache: ignoreCache}).one(attrs.lazySrc).get().then(function(img){
                        elm.src = 'data:image/png;base64,' + img.Image;
                        elm.className += ' fade-in one';
                    });
                }
            };

            // Checks if top edge of element is at bottom edge of window
            var isBecomingVisible = function (elmOffset) {
                return elmOffset < $window.pageYOffset + $window.innerHeight + 700;
            };

            var link = function (scope, element, attrs) {
                var elm = element[0],
                    loaded,
                    unbindLazySrc;

                var scroller = element.closest('.scroller')[0] || $window;

                var scrollListener = _.throttle(function shouldLoad(){
                    if (loaded) {
                        return;
                    }

                    if(!elm){
                        //could get fired after $scope.$destroy due to throttling
                        return;
                    }

                    var offset = elm.getBoundingClientRect().top;

                    if (isBecomingVisible(offset)) {
                        loadImg(elm, attrs);
                        loaded = true;

                        //if this img is already visible then observe the lazySrc to update the img if it changes
                        unbindLazySrc = attrs.$observe('lazySrc', function(){
                            loadImg(elm, attrs);
                        });
                        removeEventListeners();
                    }
                }, uxConstants.lazySrcThrottle);

                function removeEventListeners() {
                    scroller.removeEventListener('touchmove', scrollListener);
                    scroller.removeEventListener('mousemove', scrollListener);
                    scroller.removeEventListener('mousewheel', scrollListener);
                }

                scroller.addEventListener('touchmove', scrollListener);
                scroller.addEventListener('mousemove', scrollListener);
                scroller.addEventListener('mousewheel', scrollListener);

                var unbindUpdateSrc = scope.$on('updateSrc', function(e, args){
                    if(_.includes(attrs.lazySrc, args)) {
                        loadImg(elm, attrs, true);
                    }
                });

                //Check if image should be loaded immediately.
                //Do it in a timeout so that it doesnt block rendering the elements.
                //getBoundingClientRect was really slow inside an ng-repeat with ~150 items.
                //getBoundingClientRect took approximately 20% of the total time to render the ng-repeat
                $timeout(scrollListener, 0);

                scope.$on('$destroy', function(){
                    removeEventListeners();
                    unbindUpdateSrc();
                    if(unbindLazySrc) {
                        unbindLazySrc();
                    }
                    scrollListener = elm = element = null;
                });
            };

            return {
                restrict: 'A',
                link: link
            };
        }]);
